import React from 'react';

/**
 * `ButtonConfirm` is a thin styled wrapper around the shared `Button`
 * component.
 *
 * It applies the base "primary" button classes plus the `cms-btn-confirm` CMS
 * hook class, and forwards all behaviour (disabled/waiting/click handling) to
 * `Button`.
 */

import Button from './Button';

type ButtonConfirmProps = {
  name: string;
  text: string;
  disabled?: boolean;
  onClick: (callback?: () => void) => void;
  waitText?: string;
  waitValue?: boolean;
  waitOnClick?: boolean;
  additionalClassNames?: string;
};

export const ButtonConfirm = ({
  name,
  text,
  disabled,
  onClick,
  waitText,
  waitValue,
  waitOnClick,
  additionalClassNames
}: ButtonConfirmProps): JSX.Element => {
  let classes = 'button button-basic';

  if (additionalClassNames) {
    classes += ` ${additionalClassNames}`;
  }

  classes += ' cms-btn-confirm';

  return (
    <Button
      name={name}
      text={text}
      disabled={disabled}
      className={classes}
      onClick={onClick}
      waitValue={waitValue}
      waitText={waitText}
      waitOnClick={waitOnClick}
    />
  );
};
